import React from "react";
import AppBar from "../app-bar/app-bar";
import PharmaciesTable from "../data-tables-distributor/pharmacy/pharmacies-table";
import {useUser} from "../providers/user-context";

function PharmaciesPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "IMPORTER" && <PharmaciesTable navOpen={navOpen}/>}
        </div>
    );
}
export default PharmaciesPage;
